import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from '@store/reducers'
import { thunk } from 'redux-thunk'

const finalCreateStore = compose(applyMiddleware(thunk))(createStore)

export default function Store(initialState) {
    return finalCreateStore(rootReducer, initialState)
}